import { createAction, props, union } from '@ngrx/store';

import { FinnairCart } from '@fcom/dapi/api/models';

export const creationStart = createAction('[CartActions] CreationStart');
export const creationSuccess = createAction('[CartActions] CreationSuccess', props<{ cartUrl: string }>());
export const creationError = createAction('[CartActions] CreationError');
export const loadStart = createAction('[CartActions] LoadStart');
export const loadError = createAction('[CartActions] LoadError');
export const updateStart = createAction('[CartActions] UpdateStart');
export const updateError = createAction('[CartActions] UpdateError');
/**
 * The update was unsuccessful, but does not affect the whole cart
 * @type {string}
 */
export const updateNotCompleted = createAction('[CartActions] UpdateNotCompleted');
export const reset = createAction('[CartActions] Reset');
export const setCartData = createAction('[CartActions] SetCartData', props<{ cartData: FinnairCart }>());
export const isUpdatingPartialCart = createAction(
  '[CartActions] isUpdatingPartialCart',
  props<{ cartPartIds: string | string[] }>()
);
export const errorUpdatingPartialCart = createAction(
  '[CartActions] ErrorUpdatingPartialCart',
  props<{ cartPartIds: string | string[] }>()
);
export const clearUpdatingPartialCart = createAction(
  '[CartActions] clearUpdatingPartialCart',
  props<{ cartPartIds: string | string[] }>()
);
export const acceptTerms = createAction('[CartActions] AcceptTerms');

export const all = union({
  creationStart,
  creationSuccess,
  creationError,
  loadStart,
  loadError,
  updateStart,
  updateError,
  updateNotCompleted,
  reset,
  setCartData,
  isUpdatingPartialCart,
  errorUpdatingPartialCart,
  clearUpdatingPartialCart,
  acceptTerms,
});

export type ActionsUnion = typeof all;
